import ReportsSerializer from './base';

export default class ReportTemplate extends ReportsSerializer {
  attrs = {
    type: { serialize: true },
  };
}
